var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.video'] = (function () {
    'use strict';

    const CONFIG = {
        VIDEO_SELECTOR: ".partial-video",
        PLAY_SELECTOR: ".partial-video__button",
        PLACEHOLDER_SELECTOR: ".partial-video__placeholder",
        SOURCE_ATTRIBUTE: "data-src",
        TITLE_ATTRIBUTE: "data-title"
    };

    // Initializes video component event listeners
    const initialize = (video) => {

        // attach event listener for individual video's play button
        const playButton = video.querySelector(CONFIG.PLAY_SELECTOR);
        playButton.addEventListener("click", function () {
            play(video);
        });

        // attach event listener for stopping video in a modal: stop video when modal is closed
        const modalElement = video.closest(".modal");
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
            modalElement.addEventListener('hidden.bs.modal', function (event) {
                stop(video);
            });
        }
    }

    // Plays the selected video and stops others
    const play = (video) => {

        // stop all videos before starting intended video
        const videos = document.querySelectorAll(CONFIG.VIDEO_SELECTOR);
        videos.forEach(video => { stop(video); });

        // play the intended video
        const target = video.querySelector(CONFIG.PLACEHOLDER_SELECTOR);
        const button = video.querySelector(CONFIG.PLAY_SELECTOR);
        const source = button?.getAttribute(CONFIG.SOURCE_ATTRIBUTE);
        const title = button?.getAttribute(CONFIG.TITLE_ATTRIBUTE);

        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                target.innerHTML = getYoutubeIframe(source, title);
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                target.innerHTML = getVimeoIframe(source, title);
                break;
            default:
                console.log("Could not locate video content");
        };

        button.style.display = "none";
        target.style.display = "block";
    }

    // Stops the video and resets the UI
    const stop = (video) => {
        const target = video.querySelector(CONFIG.PLACEHOLDER_SELECTOR);
        const button = video.querySelector(CONFIG.PLAY_SELECTOR);

        target.style.display = "none";
        target.replaceChildren();
        button.style.display = "block";
    }

    // Returns YouTube embed iframe HTML
    const getYoutubeIframe = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>`;
    }

    // Returns Vimeo embed iframe HTML
    const getVimeoIframe = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen></iframe>`;
    }

    return {
        initialize
    };

})();